export default __webpack_public_path__ + "static/media/pilz-02.a845b242.png";